// extracted by mini-css-extract-plugin
export default {"container":"TextHalf_container__vN5HJ","left":"TextHalf_left__waAuf","right":"TextHalf_right__QkQLa"};